<template>
  <div class="container">
    <h2 class="title">{{$t('faq.title')}}</h2>
    <div v-bem>
      <div v-bem:intro class="row">
        <div class="col-2 col-m-3">
          <img v-bem:intro:icon src="@/assets/img/icons/faq.svg" alt="faq icon">
        </div>
        <div class="col-10 col-m-9">
          <div v-bem:intro:content>
            <h4>{{$t('faq.sub-title')}}</h4>
          </div>
        </div>
      </div>
      <div v-bem:accordion="{rtl: $i18n.locale === 'ar'}">
        <v-collapse-wrapper
          v-bem:accordion:item
          v-for="(item, index) in items"
          :key="index"
          v-on:onStatusChange="({status}) => item.status = status"
        >
          <div v-bem:accordion:item:header="{ active: item.status }" v-collapse-toggle>
            <img src="@/assets/img/icons/question.svg" alt="question">
            <p>{{$t(`faq.list.${index}.qst`)}}</p>
          </div>
          <div v-bem:accordion:item:content v-collapse-content>
            <div class="text">
              <div v-html="$t(`faq.list.${index}.answer`)"></div>
            </div>
          </div>
        </v-collapse-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  computed: {
    items: () => [...Array(11)].map(() => ({status: false}))
  }
}
</script>

<style scoped lang="scss">
.faq {
  max-width: rem(900);
  margin: 0 auto;
  &__intro {
    margin-bottom: rem(30);
    &-icon {
      max-width: rem(100);
    }
    &-content {
      padding: rem(40) rem(30);
      background-color: rgba(var(--primary-color), 1);
      h4 {
        @include font-size(24);
        font-family: var(--primary-font-bold);
        color: $white;
        font-weight: normal;
        text-transform: uppercase;
      }
    }
  }
  &__accordion {
    $this: &;
    &-item {
      background-color: $gray;
      margin-bottom: rem(10);
      &-header {
        cursor: pointer;
        position: relative;
        padding: rem(20) rem(30);
        img {
          max-width: rem(30);
          vertical-align: middle;
          margin-right: rem(20);
        }
        p {
          display: inline-block;
          font-weight: bold;
        }
        &::after {
          content: "";
          @extend %transform-center-vertical;
          top: 55%;
          right: rem(30);
          border-width: rem(10);
          border-style: solid;
          border-color: $dark transparent transparent transparent;
        }
        &--active {
          &::after {
            top: 40%;
            border-color: transparent transparent rgba(var(--primary-color), 1) transparent;
          }
        }
      }
      &-content {
        .text {
          padding: rem(10) rem(80) rem(30) rem(80);
          /deep/ p {
            margin: rem(10) 0;
          }
          /deep/ a {
            color: rgba(var(--primary-color), 1);
            font-family: $secondary-font-bold;
          }
        }
      }
    }
    &--rtl {
      .faq__accordion-item-header {
        img {
          margin-right: 0;
          margin-left: rem(20);
        }
        &::after {
          right: initial;
          left: rem(30);
        }
      }
    }
  }
  @include breakpoint('charmander') {
    &__intro {
      margin-bottom: rem(10);
      &-icon {
        max-width: rem(60);
      }
      &-content {
        padding: rem(10) rem(20);
        h4 {
          @include font-size(15);
          margin-bottom: rem(5);
        }
        p {
          @include font-size(14);
        }
      }
    }
    &__accordion {
      &-item {
        &-header {
          padding: rem(12) rem(22) rem(12) rem(10);
          img {
            display: none;
          }
          p {
            @include font-size(14);
          }
          &::after {
            right: rem(5);
            border-width: rem(8);
          }
        }
        &-content {
          .text {
            @include font-size(14);
            padding: rem(10) rem(10) rem(20) rem(10);
          }
        }
      }
      &--rtl {
        .faq__accordion-item-header {
          padding: rem(12) rem(10) rem(12) rem(22);
          &::after {
            left: rem(5);
          }
        }
      }
    }
  }
}
</style>